import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FaMicrophone } from "react-icons/fa";
import demo from "../../Assets/Speakers/demo.jpeg";
import "./Speakers.css";

import img2 from "../../Assets/Speakers/Dr N Vijayaprabu.png";
import img3 from "../../Assets/Speakers/Dr G Bharanidharan.png";
import img4 from "../../Assets/Speakers/Dr S Suresh S.png";
import img5 from "../../Assets/Speakers/Dr K Muthuvelu.png";
// PD 01: PANEL DISCUSSION (SRS/SBRT)
import img6 from "../../Assets/Speakers/MR M MARIYAPPAN.png";
import img7 from "../../Assets/Speakers/DR S SHAMSUDEEN.png";
import img8 from "../../Assets/Speakers/MR S ANTO VAZ.png";
import img9 from "../../Assets/Speakers/DR PONNUSAMY.png";
import img10 from "../../Assets/Speakers/MR SAJI OOMMEN.png";
import img11 from "../../Assets/Speakers/DR S VENDHAN.png";
// SCIENTIFIC SESSION I
import img12 from "../../Assets/Speakers/demo.jpeg";
import img13 from "../../Assets/Speakers/DR M SADIQ.png";
import img14 from "../../Assets/Speakers/DR V SAI SUBRAMANIAN.png";
import img15 from "../../Assets/Speakers/demo.jpeg";
import img16 from "../../Assets/Speakers/demo.jpeg";
// PD 02: PANEL DISCUSSION (TMI/TMLI)
import img17 from "../../Assets/Speakers/Dr Harish Kumar.png";
import img18 from "../../Assets/Speakers/DR STEVE THOMAS.png";
import img19 from "../../Assets/Speakers/DR B RAJESH.png";
import img20 from "../../Assets/Speakers/DR S SHAM.png";
import img21 from "../../Assets/Speakers/DR S EBENEZER.png";
import img22 from "../../Assets/Speakers/MR D YOGARAJ.png";
// QUIZ COMPETITION ON MEDICAL PHYSICS
import img23 from "../../Assets/Speakers/DR B GOWRI.png";
import img24 from "../../Assets/Speakers/MS SIDONIYA VALAS.png";
import img25 from "../../Assets/Speakers/MR GODWIN PAUL DAS.png";
// E-POSTER EVALUATION
import img26 from "../../Assets/Speakers/Dr N Vijayaprabu.png";
import img27 from "../../Assets/Speakers/DR V HEMALATHA PRIYADARSHNI.png";
import img28 from "../../Assets/Speakers/DR PUTHA SUMAN KUMAR.png";

//  27.09.2025 - DAY 2 (SATURDAY)
// WELLNESS SESSION
import img29 from "../../Assets/Speakers/MS S SARASWATHI CHITRA.png";
// CME - ACADEMIC SESSION
import img30 from "../../Assets/Speakers/DR R M NEHRU.png";
import img31 from "../../Assets/Speakers/DR P TAMIL KUMAR.png";
import img32 from "../../Assets/Speakers/DR T GANESH.png";
// SCIENTIFIC SESSION II
import img33 from "../../Assets/Speakers/DR SIMON PAVAMANI.png";
import img34 from "../../Assets/Speakers/DR N SURENDARAN.png";
import img35 from "../../Assets/Speakers/DR B PAUL RAVINDRAN.png";
// ORATION II
import img36 from "../../Assets/Speakers/Dr N Vijayaprabu.png";
import img37 from "../../Assets/Speakers/Dr G Bharanidharan.png";
import img38 from "../../Assets/Speakers/demo.jpeg";
import img39 from "../../Assets/Speakers/DR V SUBRAMANI.png";
// ORATION III
import img40 from "../../Assets/Speakers/Dr N Vijayaprabu.png";
import img41 from "../../Assets/Speakers/Dr G Bharanidharan.png";
import img42 from "../../Assets/Speakers/DR A V LAKSHMANAN.png";
import img43 from "../../Assets/Speakers/DR ALEXANDER JOHN.png";
// SCIENTIFIC SESSION III
import img44 from "../../Assets/Speakers/DR P KALIYAPPAN.png";
import img45 from "../../Assets/Speakers/DR S PANEERSELVAM.png";
import img46 from "../../Assets/Speakers/demo.jpeg";
import img47 from "../../Assets/Speakers/demo.jpeg";
import img48 from "../../Assets/Speakers/demo.jpeg";
// TRADE SESSION
import img49 from "../../Assets/Speakers/DR E VARATHARAJAN.png";
import img50 from "../../Assets/Speakers/DR S MAHENDRA MOHAN.png";
import img51 from "../../Assets/Speakers/DR S SENTHIL KUMAR.png";
// SCIENTIFIC SESSION IV
import img52 from "../../Assets/Speakers/DR S D SHARMA.png";
import img53 from "../../Assets/Speakers/DR TIMOTHY PEACE.png";
import img54 from "../../Assets/Speakers/DR GANAPATHY KRISHNAN.png";
import img55 from "../../Assets/Speakers/demo.jpeg";
import img56 from "../../Assets/Speakers/demo.jpeg";
// SCIENTIFIC SESSION V
import img57 from "../../Assets/Speakers/DR J VIJAYALAKSHMI.png";
import img58 from "../../Assets/Speakers/DR A KOPPERUNTHDEVI.png";
import img59 from "../../Assets/Speakers/DR K SARAVANAN.png";
import img60 from "../../Assets/Speakers/demo.jpeg";
import img61 from "../../Assets/Speakers/demo.jpeg";
// SCIENTIFIC SESSION VI
import img62 from "../../Assets/Speakers/DR T GANESH.png";
import img63 from "../../Assets/Speakers/demo.jpeg";
import img64 from "../../Assets/Speakers/DR S SENTHIL KUMAR.png";
import img65 from "../../Assets/Speakers/demo.jpeg";
import img66 from "../../Assets/Speakers/demo.jpeg";

// PD 03: PANEL DISCUSSION (Medical Physics Education)
import img67 from "../../Assets/Speakers/DR K THAYALAN.png";
import img68 from "../../Assets/Speakers/DR P ARUNA.png";
import img69 from "../../Assets/Speakers/DR S D SHARMA.png";
import img70 from "../../Assets/Speakers/DR M RAVIKUMAR.png";
import img71 from "../../Assets/Speakers/DR C S SUREKA.png";

const sectionsRaw = [
  //  26.09.2025 - DAY 1 (FRIDAY)
  {
    heading: "ORATION I ",
    speakers: [
      {
        name: "Dr N Vijayaprabu",
        role: "Chairman, TNPY AMPI",
        img: img2,
        tag: "Chairperson",
      },
      {
        name: "Dr G Bharanidharan",
        role: "Secretary, TNPY AMPI",
        img: img3,
        tag: "Chairperson",
      },
      {
        name: "Dr S Suresh S",
        role: "Head - Medical Oncology, Apollo Hospitals, Vanagaram",
        img: img4,
        tag: "Chairperson",
      },
      {
        name: "Dr K Muthuvelu",
        role: "Professor of Radiological Physics, SRMMCH&RC, Kattangulathur",
        img: img5,
        tag: "ORATOR",
      },
    ],
  },
  {
    heading: "PD 01: PANEL DISCUSSION (SRS/SBRT)",
    speakers: [
      {
        name: "MR M MARIYAPPAN",
        role: "MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET",
        img: img6,
        tag: "MODERATOR",
      },
      {
        name: "DR S SHAMSUDEEN",
        role: "RADIATION ONCOLOGIST, APOLLO HOSPITALS, TEYNAMPET",
        img: img7,
        tag: "PANELIST",
      },
      {
        name: "MR S ANTO VAZ",
        role: "MEDICAL PHYSICIST, KOVAI MEDICAL CENTRE AND HOSPITAL, COIMBATORE",
        img: img8,
        tag: "PANELIST",
      },
      {
        name: "DR PONNUSAMY",
        role: "MEDICAL PHYSICIST , NIMHANS, BANGALORE",
        img: img9,
        tag: "PANELIST",
      },
      {
        name: "MR SAJI OOMMEN",
        role: "MEDICALPHYSICIST, APOLLO HOSPITALS, DELHI",
        img: img10,
        tag: "PANELIST",
      },
      {
        name: "DR S VENDHAN",
        role: "MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET",
        img: img11,
        tag: "PANELIST",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION I",
    speakers: [
      {
        name: "DR V MURALI",
        role: "FORMER CHIEF MEDICAL PHYSICIST, APOLLO HOSPITALS, TEYNAMPET",
        img: img12,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR M SADIQ",
        role: "RADIATION ONCOLOGIST, APOLLO HOSPITALS, TEYNAMPET",
        img: img13,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR V SAI SUBRAMANIAN",
        role: "CHIEF MEDICAL PHYSICIST, YASHODA HOSPITALS, HYDERABAD",
        img: img14,
        tag: "INVITED TALK",
      },
      {
        name: "MS M GOWRI",
        role: "ANNA UNIVERSITY, CHENNAI",
        img: img15,
        tag: "ORAL PAPER",
      },
      {
        name: "MS T M HEMAVATHI",
        role: "SRI RAMACHANDRA INSTITUTE OF HIGHER EDUCATION AND RESEARCH (SRIHER), CHENNAI",
        img: img16,
        tag: "ORAL PAPER",
      },
    ],
  },
  {
    heading: "PD 02: PANEL DISCUSSION (TMI/TMLI)",
    speakers: [
      {
        name: "DR HARISH KUMAR",
        role: "RADIATION ONCOLOGIST, APOLLO HOSPITALS, VANAGARAM",
        img: img17,
        tag: "MODERATOR",
      },
      {
        name: "DR STEVE THOMAS",
        role: "HAEMATOLOGIST, SRMC, CHENNAI",
        img: img18,
        tag: "PANELIST",
      },
      {
        name: "DR B RAJESH",
        role: "RADIATION ONCOLOGIST, CMC, VELLORE",
        img: img19,
        tag: "PANELIST",
      },
      {
        name: "DR S SHAM",
        role: "RADIATION ONCOLOGIST, APCC, CHENNAI",
        img: img20,
        tag: "PANELIST",
      },
      {
        name: "DR S EBENEZER",
        role: "MEDICAL PHYSICIST, CMC, VELLORE",
        img: img21,
        tag: "PANELIST",
      },
      {
        name: "MR D YOGARAJ",
        role: "MEDICAL PHYSICIST, APOLLO HOSPITALS, VIZAG",
        img: img22,
        tag: "PANELIST",
      },
    ],
  },
  {
    heading: "QUIZ COMPETITION ON MEDICAL PHYSICS",
    speakers: [
      {
        name: "DR B GOWRI",
        role: "ASST PROFESSOR, GAAMCH, KANCHIPURRAM",
        img: img23,
        tag: "QUIZ MASTER",
      },
      {
        name: "MS SIDONIYA VALAS",
        role: "CHIEF MEDICAL PHYSICIST, DRKMH, CHENNAI",
        img: img24,
        tag: "QUIZ MASTER",
      },
      {
        name: "MR GODWIN PAUL DAS",
        role: "MEDICAL PHYSICIST, OGMH, CHENNAI",
        img: img25,
        tag: "QUIZ MASTER",
      },
    ],
  },
  {
    heading: "E-POSTER EVALUATION",
    speakers: [
      {
        name: "DR N VIJAYAPRABU",
        role: "PROFESSOR, JIPMER, PUDUCHERRY",
        img: img26,
        tag: "EVALUATOR",
      },
      {
        name: "DR V HEMALATHA PRIYADARSHNI",
        role: "MEDICAL PHYSICIST, RGH, CHENNAI",
        img: img27,
        tag: "EVALUATOR",
      },
      {
        name: "DR PUTHA SUMAN KUMAR",
        role: "CHIEF MEDICAL PHYSICIST, MGM, CHENNAI",
        img: img28,
        tag: "EVALUATOR",
      },
    ],
  },

  //  27.09.2025 - DAY 2 (SATURDAY)
  {
    heading: "WELLNESS SESSION",
    speakers: [
      {
        name: "MS S SARASWATHI CHITRA",
        role: "CHIEF MEDICAL PHYSICIST AND RSO, APOLLO HOSPITALS, TEYNAMPET",
        img: img29,
        tag: "INVITED TALK",
      },
    ],
  },
  {
    heading: "CME - ACADEMIC SESSION",
    speakers: [
      {
        name: "DR R M NEHRU",
        role: "FORMER SCIENTIST, OFFICER IN CHARGE,SRRC,AERB,CHENNAI",
        img: img30,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR P TAMIL KUMAR",
        role: "CHIEF MEDICAL PHYSICIST, DR.RAI MEDICAL CENTER, CHENNAI",
        img: img31,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR T GANESH",
        role: "FORMER CHIEF MEDICAL PHYSICIST, MANIPAL HOSPITALS, DELHI",
        img: img32,
        tag: "INVITED TALK",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION II",
    speakers: [
      {
        name: "DR SIMON PAVAMANI",
        role: "SR. PROFESSOR OF RADIATION ONCOLOGY, CMC, VELLORE",
        img: img33,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR N SURENDARAN",
        role: "PROFESSOR OF RADIOLOGICAL PHYSICS, SIMS, CHENNAI",
        img: img34,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR B PAUL RAVINDRAN",
        role: "PRINCIPAL AND CHIEF MEDICAL PHYSICIST, NERMPI,CIHSR, NAGALAND",
        img: img35,
        tag: "INVITED TALK",
      },
    ],
  },
  {
    heading: "ORATION II",
    speakers: [
      {
        name: "DR N VIJAYAPRABU",
        role: "CHAIRMAN, TNPY AMPI",
        img: img36,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR G BHARANIDHARAN",
        role: "SECRETARY, TNPY AMPI",
        img: img37,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR DAYANANDA SHARMA",
        role: "HEAD - MEDICAL PHYSICS, APCC, CHENNAI",
        img: img38,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR V SUBRAMANI",
        role: "ASSO. PROFESSOR, AIIMS, NEW DELHI",
        img: img39,
        tag: "ORATOR",
      },
    ],
  },
  {
    heading: "ORATION III",
    speakers: [
      {
        name: "DR N VIJAYAPRABU",
        role: "CHAIRMAN, TNPY AMPI",
        img: img40,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR G BHARANIDHARAN",
        role: "SECRETARY, TNPY AMPI",
        img: img41,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR A V LAKSHMANAN",
        role: "FORMER DIRECTOR (ADMIN), CIA, ADAYAR, CHENNAI",
        img: img42,
        tag: "DISTINGUISHED GUEST",
      },
      {
        name: "DR ALEXANDER JOHN",
        role: "PROFESSOR OF RADIATION ONCOLOGY, CIA, ADAYAR, CHENNAI",
        img: img43,
        tag: "ORATOR",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION III",
    speakers: [
      {
        name: "DR P KALIYAPPAN",
        role: "PROFESSOR OF MEDICAL PHYSICS, SREE BALAJI MEDICAL COLLEGE AND HOSPITAL, CHENNAI",
        img: img44,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR S PANEERSELVAM",
        role: "ADJUNCT FACULTY, SRMC, CHENNAI",
        img: img45,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR M SENTHIL KUMAR",
        role: "SCIENTIFIC OFFICER, AERB, CHENNAI",
        img: img46,
        tag: "INVITED TALK",
      },
      {
        name: "MS K SAITHANI BEGUM",
        role: "BHARATHIAR UNIVERSITY, COIMBATORE",
        img: img47,
        tag: "ORAL PAPER",
      },
      {
        name: "MR S K NASIM ALI",
        role: "CHRISTIAN MEDICAL COLLEGE, VELLORE",
        img: img48,
        tag: "ORAL PAPER",
      },
    ],
  },
  {
    heading: "TRADE SESSION",
    speakers: [
      {
        name: "DR E VARATHARAJAN",
        role: "CHIEF MEDICAL PHYSICIST, BILLROTH, CHENNAI",
        img: img49,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR S MAHENDRA MOHAN",
        role: "CHIEF MEDICAL PHYSICIST, MERIDIAN HOSPITAL, CHENNAI",
        img: img50,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR S SENTHIL KUMAR",
        role: "PROFESSOR OF RADIOLOGICAL PHYSICS, MMC, MADURAI",
        img: img51,
        tag: "CHAIRPERSON",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION IV",
    speakers: [
      {
        name: "DR S D SHARMA",
        role: "HEAD MEDICAL PHYSICS, BARC, MUMBAI",
        img: img52,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR TIMOTHY PEACE",
        role: "ASSO. PROFESSOR OF RADIOLOGICAL PHYSICS, CMC, VELLORE",
        img: img53,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR GANAPATHY KRISHNAN",
        role: "LEAD MEDICAL PHYSICIST, APCC, CHENNAI",
        img: img54,
        tag: "INVITED TALK",
      },
      {
        name: "MS P JENIFER SNEHA",
        role: "CHRISTIAN MEDICAL COLLEGE, VELLORE",
        img: img55,
        tag: "ORAL PAPER",
      },
      {
        name: "MS S SUSHMA EVANGELIN",
        role: "KALYAN SINGH SUPER SPECIALITY CANCER INSTITUTE, LUCKNOW",
        img: img56,
        tag: "ORAL PAPER",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION V",
    speakers: [
      {
        name: "DR J VIJAYALAKSHMI",
        role: "PROFESSOR OF RADIOLOGICAL PHYSICS, SMC, CHENNAI",
        img: img57,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR A KOPPERUNTHDEVI",
        role: "PROFESSOR RADIOLOGICAL PHYSICS, MMC, CHENNAI",
        img: img58,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR K SARAVANAN",
        role: "ASST PROFESSOR RADIOLOGICAL PHYSICS, JIPMER, PUDUCHERRY",
        img: img59,
        tag: "INVITED TALK",
      },
      {
        name: "DR VENKATESAN KALIYAPERUMAL",
        role: "SCIENTIST D,DRDO, DELHI",
        img: img60,
        tag: "ORAL PAPER",
      },
      {
        name: "MS P S JANANI",
        role: "BHARATHIAR UNIVERSITY, COIMBATORE",
        img: img61,
        tag: "ORAL PAPER",
      },
    ],
  },
  {
    heading: "SCIENTIFIC SESSION VI",
    speakers: [
      {
        name: "DR T GANESH",
        role: "FORMER CHIEF MEDICAL PHYSICIST, MANIPAL HOSPITALS, DELHI",
        img: img62,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR MOHAN RAMACHANDRAN",
        role: "SENIOR MEDICAL PHYSICIST, UAE",
        img: img63,
        tag: "CHAIRPERSON",
      },
      {
        name: "DR S SENTHILKUMAR",
        role: "MADURAI MEDICAL COLLEGE, MADURAI",
        img: img64,
        tag: "ORAL PAPER",
      },
      {
        name: "MS KEERTHANA SUDANDRA BABU",
        role: "APOLLO CANCER CENTRE, TEYNAMPET",
        img: img65,
        tag: "ORAL PAPER",
      },
      {
        name: "MR A S JIM ELLIOT",
        role: "CHRISTIAN MEDICAL COLLEGE, VELLORE",
        img: img66,
        tag: "ORAL PAPER",
      },
    ],
  },
  {
    heading: "PD 03: PANEL DISCUSSION (Medical Physics Education)",
    speakers: [
      {
        name: "DR K THAYALAN",
        role: "RTD PROFESSOR OF RADIOLOGICAL PHYSICS",
        img: img67,
        tag: "MODERATOR",
      },
      {
        name: "DR P ARUNA",
        role: "RTD. PROFESSOR, ANNA UNIVERSITY, CHENNAI",
        img: img68,
        tag: "PANELIST",
      },
      {
        name: "DR S D SHARMA",
        role: "HEAD MEDICAL PHYSICS, BARC, MUMBAI",
        img: img69,
        tag: "PANELIST",
      },
      {
        name: "DR M RAVIKUMAR",
        role: "DIRECTOR OF MEDICAL PHYSICS, SSCHRC, BANGALORE",
        img: img70,
        tag: "PANELIST",
      },
      {
        name: "DR C S SUREKA",
        role: "ASSO. PROFESSOR, BHARATHIAR UNIVERSITY, COIMBATORE",
        img: img71,
        tag: "PANELIST",
      },
    ],
  },
];

// Assign continuous CV numbers
let cvCounter = 1;
const sections = sectionsRaw.map((section) => ({
  ...section,
  speakers: section.speakers.map((sp) => {
    const cvNum = cvCounter < 10 ? `0${cvCounter}` : `${cvCounter}`;
    cvCounter++;
    return { ...sp, cv: cvNum };
  }),
}));

const Speakers = () => {
  React.useEffect(() => {
    const cards = document.querySelectorAll(".speaker-card");
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);
  return (
    <div className="container py-5" style={{ marginTop: "80px" }}>
      <div className="text-center mb-5">
        <h1
          className="fw-bold"
          style={{ color: "#1B5F7D", fontSize: "2.5rem", letterSpacing: "2px" }}
        >
          Our Speakers
        </h1>
        <p>We are glad to present our distinguished speakers for the event.</p>
      </div>
      {/* Main headers for each day */}
      <div>
        <h2
          className="fw-bold mb-4"
          style={{
            color: "#195f7d",
            fontSize: "2rem",
            letterSpacing: "1px",
            borderBottom: "2px solid #195f7d",
            paddingBottom: "8px",
            textAlign: "center",
          }}
        >
          26.09.2025 - DAY 1 (FRIDAY)
        </h2>
        {sections.slice(0, 6).map((section, sidx) => (
          <div key={sidx} className="mb-5">
            <h3
              className="fw-bold mb-4"
              style={{
                color: "#1B5F7D",
                borderLeft: "6px solid #1B5F7D",
                paddingLeft: "12px",
              }}
            >
              {section.heading}
            </h3>
            <Row className="g-4">
              {section.speakers.map((sp, idx) => (
                <Col xs={12} md={6} lg={6} key={idx}>
                  <Card
                    className={`shadow-sm border-0 position-relative speaker-card ${
                      idx % 2 === 0 ? "slide-left" : "slide-right"
                    }`}
                    style={{
                      borderRadius: "22px",
                      background:
                        "linear-gradient(90deg, #e9f5fa 60%, #fff 100%)",
                      borderLeft: "8px solid #1B5F7D",
                      padding: "24px 0",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    {/* Speaker tag top left (show any tag from data) */}
                    {sp.tag && (
                      <span
                        style={{
                          position: "absolute",
                          top: "12px",
                          left: "18px",
                          background: "#195f7d",
                          color: "#fff",
                          fontSize: "0.85rem",
                          fontWeight: 700,
                          borderRadius: "8px",
                          padding: "4px 14px",
                          zIndex: 10,
                          boxShadow: "0 2px 8px rgba(27,95,125,0.10)",
                        }}
                      >
                        {sp.tag}
                      </span>
                    )}
                    {/* More prominent decorative bend in top right corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-1px",
                        right: "-1px",
                        width: "90px",
                        height: "90px",
                        background: "#1B5F7D",
                        borderBottomLeftRadius: "90px 70px",
                        border: "6px solid #fff",
                        zIndex: 2,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-end",
                      }}
                    >
                      <FaMicrophone
                        style={{
                          color: "#fff",
                          fontSize: "2rem",
                          margin: "12px 12px 0 0",
                        }}
                      />
                    </div>
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ position: "relative", zIndex: 3 }}
                    >
                      <div
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          boxShadow: "0 4px 16px rgba(27, 95, 125, 0.10)",
                          marginBottom: "18px",
                        }}
                      >
                        <img
                          src={sp.img}
                          alt={sp.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          color: "#1B5F7D",
                          fontWeight: 800,
                          fontSize: "1.2rem",
                          letterSpacing: "2px",
                          marginBottom: "6px",
                        }}
                      >
                        {sp.cv ? sp.cv : "CV Not Available"}
                      </div>
                      <div
                        style={{
                          fontWeight: 900,
                          fontSize: "1.15rem",
                          color: "#222",
                          textAlign: "center",
                          textTransform: "uppercase",
                          marginBottom: "8px",
                        }}
                      >
                        {sp.name}
                      </div>
                      <div
                        style={{
                          fontSize: "1rem",
                          color: "#6c757d",
                          textAlign: "center",
                          fontWeight: 500,
                        }}
                      >
                        {sp.role}
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
      <div>
        <h2
          className="fw-bold mb-4"
          style={{
            color: "#195f7d",
            fontSize: "2rem",
            letterSpacing: "1px",
            borderBottom: "2px solid #195f7d",
            paddingBottom: "8px",
            textAlign: "center",
          }}
        >
          27.09.2025 - DAY 2 (SATURDAY)
        </h2>
        {sections.slice(6).map((section, sidx) => (
          <div key={sidx} className="mb-5">
            <h3
              className="fw-bold mb-4"
              style={{
                color: "#1B5F7D",
                borderLeft: "6px solid #1B5F7D",
                paddingLeft: "12px",
              }}
            >
              {section.heading}
            </h3>
            <Row className="g-4">
              {section.speakers.map((sp, idx) => (
                <Col xs={12} md={6} lg={6} key={idx}>
                  <Card
                    className={`shadow-sm border-0 position-relative speaker-card ${
                      idx % 2 === 0 ? "slide-left" : "slide-right"
                    }`}
                    style={{
                      borderRadius: "22px",
                      background:
                        "linear-gradient(90deg, #e9f5fa 60%, #fff 100%)",
                      borderLeft: "8px solid #1B5F7D",
                      padding: "24px 0",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    {/* Speaker tag top left (show any tag from data) */}
                    {sp.tag && (
                      <span
                        style={{
                          position: "absolute",
                          top: "12px",
                          left: "18px",
                          background: "#195f7d",
                          color: "#fff",
                          fontSize: "0.85rem",
                          fontWeight: 700,
                          borderRadius: "8px",
                          padding: "4px 14px",
                          zIndex: 10,
                          boxShadow: "0 2px 8px rgba(27,95,125,0.10)",
                        }}
                      >
                        {sp.tag}
                      </span>
                    )}
                    {/* More prominent decorative bend in top right corner */}
                    <div
                      style={{
                        position: "absolute",
                        top: "-1px",
                        right: "-1px",
                        width: "90px",
                        height: "90px",
                        background: "#1B5F7D",
                        borderBottomLeftRadius: "90px 70px",
                        border: "6px solid #fff",
                        zIndex: 2,
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-end",
                      }}
                    >
                      <FaMicrophone
                        style={{
                          color: "#fff",
                          fontSize: "2rem",
                          margin: "12px 12px 0 0",
                        }}
                      />
                    </div>
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{ position: "relative", zIndex: 3 }}
                    >
                      <div
                        style={{
                          width: "110px",
                          height: "110px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          boxShadow: "0 4px 16px rgba(27, 95, 125, 0.10)",
                          marginBottom: "18px",
                        }}
                      >
                        <img
                          src={sp.img}
                          alt={sp.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div
                        style={{
                          color: "#1B5F7D",
                          fontWeight: 800,
                          fontSize: "1.2rem",
                          letterSpacing: "2px",
                          marginBottom: "6px",
                        }}
                      >
                        {sp.cv ? sp.cv : "CV Not Available"}
                      </div>
                      <div
                        style={{
                          fontWeight: 900,
                          fontSize: "1.15rem",
                          color: "#222",
                          textAlign: "center",
                          textTransform: "uppercase",
                          marginBottom: "8px",
                        }}
                      >
                        {sp.name}
                      </div>
                      <div
                        style={{
                          fontSize: "1rem",
                          color: "#6c757d",
                          textAlign: "center",
                          fontWeight: 500,
                        }}
                      >
                        {sp.role}
                      </div>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Speakers;
